/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Cancel, CirclePlusIconWithoutStroke, PlayRound, TargetIcon } from '../../../Components/LandingHeader/Feedback/icons/Icons';
import TimerOptions from "../../../Components/FocusTimer/TimerOptions";

import moment from "moment";
import { setFocusTasksList } from "../../../redux/slices/TaskSlice";
import { CheckFilledIcon, CirclePlusIcon } from "../../../Components/LandingHeader/Feedback/icons/Icons";
import { setTimerFullscreen, startTimer } from "../../../redux/slices/timer";
import { arrayMoveImmutable } from 'array-move';
import { sortableContainer, sortableElement, sortableHandle } from "react-sortable-hoc";
import EditTaskList from "../../AddTasks/EditTaskList";
import { decodeToken } from "react-jwt";
import { useSocket } from "../../../SocketContext";
import { convertUrlsToLinks, verifyRepeatedTask, verifyRepeatedTaskAsPerTodoist } from "../../../Components/action/utilities";
import TaskSourceIcon from "../../Tasks/TaskSourceIcon";
import AddTaskStatic from "../../AddTasks/AddTaskStatic";
import DragIcon from "../../Tasks/DragIcon";
import RecurringIcon from "../../Tasks/RecurringIcon";
import { useLocation } from "react-router-dom";
import Tooltip from "../../../Components/common/Tooltip";
import ProjectTagIcon from "../../Tasks/ProjectTagIcon";
import { usePosthog } from "../../../PosthogProvider";
import { startFocusTimerSession } from "../../../Components/action/timer";
import TaskModal from "./TaskModal";

const DragHandle = sortableHandle(() => <span className="dragdrop-option"><DragIcon /></span>);

const SortableItem = sortableElement(({children, theme, editTaskHandler, task}) => (
  <li className="task-item li-task-list hr-line py-5 px-10"
      css={{
        background: `linear-gradient(0deg,rgba(var(--theme-mode-rgb-white),0.8),rgba(var(--theme-mode-rgb-white),0.8)),linear-gradient(0deg,var(--accent-color),var(--accent-color)), var(--accent-color) !important;`,
        'span.title': {
          color: `var(--theme-mode-color-white-reverse)`
        },
      }}

      onClick={e => editTaskHandler(e, task)}
  >
    <DragHandle />
    {children}
  </li>
));

const SortableContainer = sortableContainer(({children}) => {
    
    return (
      <ul className="ul-task-list ul-task-list-focused">{children}</ul>
    )
});

const FocusModeSettingsModal = ({todaySessions = 0, show = true, onHide}) => {
    const theme = useSelector(state => state.theme.theme);
    const {focusTasksList, taskList} = useSelector(state => state.task);
    const [isMounted, setIsMounted] = useState(false);
    const [submit, setSubmit] = useState(false);
    // const [showPopup, setShowPopup] = useState(false);
    const [editTask, setEditTask] = useState(null);
    const [updatedValue, setUpdatedValue] = useState(null);
    const dispatch = useDispatch();
    const {socket} = useSocket();
    const location = useLocation();
    const { captureEvent } = usePosthog();

    const [todayTasks, setTodayTasks] = useState(location?.hash == '#added' ? [...focusTasksList].filter(task => !task.deletedAt && task.status != 1 && verifyRepeatedTaskAsPerTodoist(task, moment().toISOString(), moment(task?.date).startOf('date').toISOString() == moment().startOf('date').toISOString())) : []);

    useEffect(() => {
        const pendingTasks = taskList.filter(t => t.status != 1 && !t.deletedAt && verifyRepeatedTaskAsPerTodoist(t, moment().toISOString(), moment(t?.date).startOf('date').toISOString() == moment().startOf('date').toISOString()));
        
        if(pendingTasks?.length > 0){
            const newTasks = pendingTasks.filter(a => !todayTasks.map(b=>b.id).includes(a.id)).map(task => (!isMounted ? task : {...task, focus: 1}));
            setTodayTasks([...newTasks, ...todayTasks]);
        }
        setIsMounted(true);
    }, [taskList])

    useEffect(() => {
        if(updatedValue !== null){
            setTodayTasks(tasks => tasks.map(task => task.id == updatedValue.id ? {...task, title: updatedValue.title, description: updatedValue.description} : task));
        }
    }, [updatedValue])

    useEffect(() => {
        const focusTasks = todayTasks.filter(task => task?.focus === 1);
        setSubmit(focusTasks.length > 0);
        dispatch(setFocusTasksList(focusTasks));
        triggerWebSocket({ action: "focusTasksList", tasks: focusTasks })
    }, [todayTasks])

    const addToFocusList = (e, task) => {
        e.preventDefault();

        setTodayTasks(todayTasks => todayTasks.map(t => t.id != task.id ? t : {...task, focus: 1}));
    };

    const removeFocusTask = (e, task) => {
        e.preventDefault();

        setTodayTasks(todayTasks => todayTasks.map(t => t.id != task.id ? t : {...task, focus: 0}));
    }

    const startTimerHandler = (e) => {
        e.preventDefault();
        if(submit){
            startFocusTimerSession();
            dispatch(startTimer('focusMode'));
            if (typeof window.chrome != 'undefined' && window?.chrome?.storage) {
                window.chrome.runtime?.sendMessage({ action: 'focus-timer-store-tabId' });
            }
            captureEvent('Focus Session Started')
            onHide(e);
        }
    }

    const onSortEnd = ({oldIndex, newIndex}) => {
        setTodayTasks(arrayMoveImmutable(todayTasks, oldIndex, newIndex))
    };

    const editTaskHandler = (e, task) => {
        if(!e.target?.closest('.task-action'))
        setEditTask(task);
    }

    const triggerWebSocket = (data) => {
        // Trigger timer in wepapp and other clients
        if (socket !== null){
            const user = decodeToken(localStorage.getItem('token'));
            socket.emit('focusTimer', {room: user['outseta:accountUid'], data});
        }
    }

    return (
        <>
        <Modal show={show} onHide={onHide} className="task-modal focus-mode-settings-modal !fixed !top-0 !left-0 !h-[100vh] !w-[100vw] !flex !items-center !justify-center !transform-none" css={{
            '.task-action-focus':{
                'svg': {
                    width: '32px',
                    height: '32px'
                }
            },
            '.type-header':{
                '&.hr-line':{
                    '&::after':{
                        left: '20px !important'
                    }
                }
            }
        }}>
            <Modal.Dialog className="!w-[752px] relative z-[99999] opacity-100">
                <Modal.Body className="modal-body-extra-padding p-0">
                    <div className="full-model md-model-updates block">
                        <div className="full-model-body">
                            <div className="body-data flex flex-col max-h-[90vh] overflow-hidden">
                                <div className='ctTitle relative'>
                                    <TargetIcon color={"var(--accent-color)"} fill={"var(--accent-color)"} />
                                    <span className='darkPrimaryColor'>Focus Session {todaySessions.length + 1}</span>
                                    <div className="flex justify-center items-center gap-[10px] mr-0 m-auto">
                                        <span className="font font-inter text-[14px] opacity-50 mr-[10px]">{focusTasksList.length > 0 && `${focusTasksList.length} Task${focusTasksList.length > 1 ? 's' : ''}`}</span>
                                        <a href="#" className="button primary" onClick={onHide}><Cancel color={"var(--accent-color)"} fill={"var(--accent-color)"} />Cancel</a>
                                        {
                                            submit
                                            ?
                                            <a href="#" className={`button primary text-white dark:text-black`} onClick={startTimerHandler} css={{
                                                background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.20) 0%, rgba(var(--theme-mode-rgb-white-reverse), 0.20) 100%), var(--accent-color)`
                                            }}><PlayRound color="#fff" dark={false} />Start Session</a>
                                            :
                                            <Tooltip text="Please add at least one task before starting your focus session." wrapperClassName="focus-settings-tooltip" className='overDue-tooltip'>
                                                <a href="#" className={`button primary text-white dark:text-black tooltip-hover opacity-20`} onClick={startTimerHandler} css={{
                                                    background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.20) 0%, rgba(var(--theme-mode-rgb-white-reverse), 0.20) 100%), var(--accent-color)`
                                                }}><PlayRound color="#fff" dark={false} />Start Session</a>
                                            </Tooltip>
                                        }
                                    </div>
                                </div>
                                <div className="focus-mode-settings-time-options">
                                    <TimerOptions /> 
                                </div>
                                <div className="py-0 px-5 pt-5"><AddTaskStatic /></div>
                                <div className="focus-session-tasks py-5 px-0 pt-0 overflow-y-auto overflow-x-hidden">
                                    <SortableContainer onSortEnd={onSortEnd} helperContainer={document.querySelector('.ul-task-list-focused')} useDragHandle>
                                        {todayTasks.map((task, index) => (
                                            task?.focus === 1
                                            ?
                                            <React.Fragment key={task.id}>
                                            {
                                                (
                                                    <SortableItem key={`item-${task.id}`} index={index} theme={theme} editTaskHandler={editTaskHandler} task={task}>
                                                    <>
                                                        <span
                                                            className="title text-black dark:text-white font-inter text-base" >
                                                            <div className="task-formatting">
                                                                <span dangerouslySetInnerHTML={{__html: convertUrlsToLinks(task?.title)}} />
                                                                {task?.description && <div className="task-description" dangerouslySetInnerHTML={{__html: convertUrlsToLinks(task?.description) ?? ''}} />}
                                                            </div>
                                                            <div className="flex items-center justify-start gap-[10px]">
                                                                <TaskSourceIcon task={task} colorPicker={`var(--accent-color)`} />
                                                                <RecurringIcon task={task} colorPicker={`var(--accent-color)`} />
                                                                <ProjectTagIcon task={task} />
                                                            </div>
                                                        </span>
                                                        <a href="#" className="task-action task-action-focus" onClick={e => removeFocusTask(e, task)}><CheckFilledIcon color={"var(--accent-color)"} /></a>
                                                    </>
                                                    </SortableItem>
                                                )
                                            }
                                            </React.Fragment>
                                            :
                                            null
                                        ))}
                                        </SortableContainer>
                                        <ul className="ul-task-list">
                                        {
                                            todayTasks.map((task, index) => (
                                                task?.focus !== 1
                                                ?
                                                <React.Fragment key={task.id}>
                                                    {
                                                    <li key={task.id} className={`task-item li-task-list hr-line py-5 px-10 group ${task.id}`}
                                                        css={{
                                                            '&:hover': {
                                                                background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), var(--accent-color) !important`,
                                                            }
                                                        }}

                                                        onClick={e => editTaskHandler(e, task)}
                                                    >
                                                        <span
                                                            className="title text-black dark:text-white group-hover:text-black dark:group-hover:text-white font-inter text-base">
                                                            <div className="task-formatting">
                                                                <span dangerouslySetInnerHTML={{__html: convertUrlsToLinks(task?.title)}} />
                                                                {task?.description && <div className="task-description" dangerouslySetInnerHTML={{__html: convertUrlsToLinks(task?.description) ?? ''}} />}
                                                            </div>
                                                            <div className="flex items-center justify-start gap-[10px]">
                                                                <TaskSourceIcon task={task} colorPicker={`var(--accent-color)`} />
                                                                <RecurringIcon task={task} colorPicker={`var(--accent-color)`} />
                                                                <ProjectTagIcon task={task} />
                                                            </div>
                                                        </span>
                                                        <a href="#" className="task-action" onClick={e => addToFocusList(e, task)}><CirclePlusIconWithoutStroke color={"var(--accent-color)"} fill={"rgb(var(--theme-mode-rgb-white))"} /></a>
                                                    </li>
                                                    }
                                                </React.Fragment>
                                                :
                                                null
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal.Dialog>
        </Modal>
        {
            editTask !== null
            &&
            <TaskModal
                show={true}
                editTaskData = {
                    {
                        hideActions: true,
                        item: editTask,
                        setUpdatedValue: setUpdatedValue,
                        setEditTaskId: setEditTask
                    }
                }
            />
        }
        </>
    )
}

export default FocusModeSettingsModal